import React, { useState, useEffect, useRef } from 'react';
import {
    List, Datagrid, SimpleList, FunctionField
} from 'react-admin';
import {
    useMediaQuery, makeStyles, FormControl, InputLabel, Select, MenuItem
} from '@material-ui/core';
import { customTheme } from "./customTheme";
import ScrollableTable from './components/ScrollableTable';
import { vehicleSvgs, hideVehicleNumber } from "./sharedData";
import CustomSearch from './components/CustomSearch';
import { useLocation } from 'react-router-dom';
import CustomPagination from './components/CustomPagination';
import moment from 'moment'
import CustomFilterCheckBox from './components/CustomFilterCheckBox';
import CustomDateTimePicker from './components/CustomDateTimePickerV2';
import config from "./config.json";
import CustomExportButton from './components/CustomExportButton';
import queryString from 'query-string';
import ParkingSearchSelector from './components/ParkingSearchSelector'
import UseAnalyticsEvent from './utils/useAnalyticsEvent';
import { saveTokens } from './utils/saveTokens';
import notify from './components/CustomUseNotify';

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
    chipCell: {
        textAlign: "center",
        padding: customTheme.spacing(1, 2),
        display: "inline-block",
        borderRadius: 50,
    },
});
const renderVehicleType = row => (
    row.vehicle_type ?
        <div style={{ display: 'flex', alignItems: "center", justifyContent: "center" }}>
            <img src={vehicleSvgs[row.vehicle_type]} style={{ width: 25, height: 25, marginRight: 8 }} alt={row.vehicle_type_label} />
            {/* row.vehicle_type_label */}
        </div>
        :
        null
);

export const AllParkingsDetails = props => {
    const eventTracker = UseAnalyticsEvent()
    const classes = useStyles();
    const location = useLocation();
    const listDataRef = useRef();
    //const notify = useNotify()
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));

    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});
    const [viewOnly] = useState(sessionStorage.getItem("view_only") === "1");
    const [filterCategory] = useState(sessionStorage.getItem("filter_category"));

    const [startDateTime, setStartDateTime] = useState(null);
    const [endDateTime, setEndDateTime] = useState(null);
    const [startDateTimeFilter, setStartDateTimeFilter] = useState(null);
    const [endDateTimeFilter, setEndDateTimeFilter] = useState(null);
    // const [allowCompanyUserCreate] = useState(sessionStorage.getItem("allow_company_user_create") === "1");
    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");

    const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));

    let searchTypeState = ["Vehicle Number"]
    const [search, setSearch] = useState(prevSearch.inputSearch)
    const [searchTypes, setSearchTypes] = useState("Vehicle Number");
    const [filterListValue, setFilterListValue] = useState(prevSearch.radioValue ? prevSearch.radioValue : null)

    let filterTypesInitState = [
        {
            filterType: "Category",
            dataList: [{ name: "PAID", id: 1 }, { name: "UNPAID", id: 2 }, { name: "FOC", id: 3 }, { name: "DROP OFF", id: 4 }],
            listType: "Static",
            caseType: "Static",
            showFilter: filterCategory !== "null" && filterCategory !== "" ? false : true
        },
        {
            resourcePath: "parkingAccessKeys",
            filterType: "Parking Name",
            dataList: [],
            searchList: [],
            listType: "Dynamic",
            resourceParam: "name",
            source: "name",
            showFilter: true,
            filterFormat: "Checkbox"
        },
        {
            filterType: "Parking Zones",
            dataList: [],
            listType: "Static",
            caseType: "Zones",
            showFilter: true
        },
    ]

    const [settingFilterFormat, setSettingFilterFormat] = useState({})
    const filter = { ...settingFilterFormat, search: { value: search ? search : "", type: searchTypes ? searchTypes : "" }, start_time: startDateTimeFilter ? moment(startDateTimeFilter).format("YYYY-MM-DD HH:mm:ss") : startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss")  :  "", end_time: endDateTimeFilter ? moment(endDateTimeFilter).format("YYYY-MM-DD HH:mm:ss") : endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : "" };

    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };

    const setTimeFilters = () => {
        setStartDateTimeFilter(startDateTime);
        setEndDateTimeFilter(endDateTime);
    };
    const renderPaymentStatus = (record) => {

        return (
            record.amount_at_exit > 0 && record.exit_user_id !== "CLEARED" && (record.amount_at_entry > 0 || record.amount_at_exit > 0) && record.free_vehicle !== 1 && record.unpaid === 0 ? <div
                className={classes.chipCell}
                style={{ color: record.mode_of_payment === "WALLET" ? "#18cc69" : record.mode_of_payment === "CASH" ? "#e99100" : "#555555", backgroundColor: record.mode_of_payment === "WALLET" ? "#16cc6919" : record.mode_of_payment === "CASH" ? "#e9910019" : "#55555519" }}
            >
                {record.mode_of_payment}
            </div> : "-"
        )
    }

    const renderPaymentStatusEntry = (record) => {
        return (
            record.amount_at_entry > 0 && record.exit_user_id !== "CLEARED" && (record.amount_at_entry > 0 || record.amount_at_exit > 0) && record.free_vehicle !== 1 && record.unpaid === 0 ? <div
                className={classes.chipCell}
                style={{ color: record.mode_of_payment_at_entry === "WALLET" ? "#18cc69" : record.mode_of_payment_at_entry === "CASH" ? "#e99100" : "#555555", backgroundColor: record.mode_of_payment_at_entry === "WALLET" ? "#16cc6919" : record.mode_of_payment_at_entry === "CASH" ? "#e9910019" : "#55555519" }}
            >
                {record.mode_of_payment_at_entry}
            </div> : "-"
        )
    }

    const renderTotalAmount = (record) => {
        return <>
            {
                record.amount_at_entry || record.amount_at_exit ? <div>
                    ₹ {record.amount_at_entry + record.amount_at_exit}
                </div> : "₹ 0"
            }
        </>
    }

    const renderCategory = (record) => {
        return (
            <div
                className={classes.chipCell}
                style={{ color: "#334d6e", backgroundColor: "#334d6e20" }}
            >
                {record.free_vehicle === 1 && "FOC"}
                {record.unpaid === 1 && "UNPAID"}
                {record.exit_user_id !== "CLEARED" && !(record.amount_at_entry > 0 || record.amount_at_exit > 0) && record.free_vehicle !== 1 && record.unpaid === 0 && "DROP OFF"}
                {record.exit_user_id !== "CLEARED" && (record.amount_at_entry > 0 || record.amount_at_exit > 0) && record.free_vehicle !== 1 && record.unpaid === 0 && "PAID"}
            </div>
        )
    }

    const renderCategoryMob = (record) => {
        return (
            <span
            >
                {record.free_vehicle === 1 && "FOC"}
                {record.unpaid === 1 && "UNPAID"}
                {record.exit_user_id !== "CLEARED" && !(record.amount_at_entry > 0 || record.amount_at_exit > 0) && record.free_vehicle !== 1 && record.unpaid === 0 && "DROP OFF"}
                {record.exit_user_id !== "CLEARED" && (record.amount_at_entry > 0 || record.amount_at_exit > 0) && record.free_vehicle !== 1 && record.unpaid === 0 && "PAID"}
            </span>
        )
    }

    // const AllParkingsDetailsActions = (props) => {
    //     const location = useLocation()
    //     const { ...rest } = props;
        
        
    //     return (
    //         <TopToolbar {...sanitizeListRestProps(rest)} style={{ display: 'block' }}>
    //             <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
    //                 {/* {total !== 0 && <CustomPagination setPage={setPage} page={page} total={total} hasNextPage={hasNextPage} hasPreviousPage={hasPreviousPage} perPage={perPage} setPerPage={setPerPage} />} */}
    //                 <CustomExportButton getCSV={getExcelFile} disabled={listDataRef.current && listDataRef.current.total === 0} style={{ marginTop: 0 }} />
    //             </div>
    //             {/* {isSmallDevice && <div style={{ display: "flex", justifyContent: "flex-start" }}>
    //                 {(startDateTimeFilter != null || endDateTimeFilter != null) && <div className='showResultTime' style={{ position: 'static', marginRight: 36, lineHeight: 2 }}>
    //                     <p>Showing Results for: {startDateTimeFilter ? moment(startDateTimeFilter).format("MMM Do, YYYY hh:mm a") : "Start"} - {endDateTimeFilter ? moment(endDateTimeFilter).format("MMM Do, YYYY hh:mm a") : "End"}</p>
    //                 </div>}
    //             </div>} */}
    //         </TopToolbar>
    //     )
    // }

   

        const getExportFile = (fileType) => {
            const {current : {total, currentSort, filterValues}} = listDataRef
            const params = {
                filter: JSON.stringify({ ...filter, ...filterValues }),
                sort: JSON.stringify([currentSort.field, currentSort.order]),
                page: 1,
                perPage: total,
                user_id: sessionStorage.getItem("user_id")
            };
            fetch(`${config.HOST_NAME}/crm/v3/allParkingsDetails?${queryString.stringify(params)}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                    'Accept': `application/${fileType}`,
                },
            })
                .then(response => {
                    saveTokens(response)
                    return response.blob()
                })
                .then(blob => {
                    const url = URL.createObjectURL(blob);
                    const tempLinkElement = document.createElement('a');
                    tempLinkElement.href = url;
                    tempLinkElement.setAttribute('download', `All Parkings Logs.${fileType}`);
                    tempLinkElement.click();
                })
                .catch(error => {
                    notify('Error Exporting Data', 'warning');
                });
        };
        
        const getExcelFile = () => {
            getExportFile("xlsx");
        };
    
        const getPDF = () => {
            getExportFile("pdf");
        };

    useEffect(() => {
        let values = {}
        // Add more types based on the filters
        if (filterListValue) {
            for (let val in filterListValue) {

                if (filterListValue[val].filterType === "Category") {
                    values = { ...values, category_type: filterListValue[val].value ? filterListValue[val].value : undefined }
                }
                if (filterListValue[val].filterType === "Parking Name") {
                    values = { ...values, parking_ids: filterListValue[val].id ? filterListValue[val].id : undefined }
                }
            }
            setSettingFilterFormat(values)
        }
        if (filterListValue === null) {
            setSettingFilterFormat({})
        }
    }, [filterListValue])

    useEffect(() => {
        eventTracker("ALL PARKING LOGS SECTION", " PARKING LOGS")
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return <div className={classes.list}>
        <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: 0 }}>
            {showFilter &&
                <ParkingSearchSelector
                    value={currentParking}
                    onChange={onParkingChange}
                    clearable={true}
                    pathName={location.pathname}
                />
            }

            {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                <FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                    <InputLabel>Zone Name</InputLabel>
                    <Select
                        value={currentParking.allZones ? "All" : currentParking.id}
                        onChange={onZoneChange}
                        label="Zone Name"
                        variant="outlined"
                    >
                        <MenuItem value="All">All</MenuItem>
                        {finalZones.map((zone, index) => (
                            <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            }
        </div>
        <div className='customStyleForDataSearchDiv'>
            <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
            <CustomDateTimePicker startDateTime={startDateTime} setStartDateTime={setStartDateTime} endDateTime={endDateTime} setEndDateTime={setEndDateTime} onChange={setTimeFilters} />
            <CustomFilterCheckBox filterTypesInitState={filterTypesInitState} filterListValue={filterListValue} setFilterListValue={setFilterListValue} pathName={location.pathname} />
            <CustomExportButton getCSV={getExcelFile} getPDF={getPDF} disabled={listDataRef.current && listDataRef.current.total === 0} />
        </div>

        <List
            {...props}
            title="Apartments"
            style={{marginTop: 20}}
            bulkActionButtons={false}
            sort={{ field: "exit_time", order: "DESC" }}
            exporter={false}
            filter={filter}
            // filters={!isSmallDevice && <Filter id="filterInputGrid">
            //     {(startDateTimeFilter != null || endDateTimeFilter != null) && <div className='showResultTime' alwaysOn style={{ marginTop: 20, minWidth: isSmallDevice ? 0 : 500 }}>
            //         <p>Showing Results for: {startDateTimeFilter ? moment(startDateTimeFilter).format("MMM Do, YYYY hh:mm a") : "Start"} - {endDateTimeFilter ? moment(endDateTimeFilter).format("MMM Do, YYYY hh:mm a") : "End"}</p>
            //     </div>}
            // </Filter>}
            empty={false}
            hasCreate={!viewOnly}
            actions={false}
            pagination={<CustomPagination setListData={(listData) => {listDataRef.current = listData}} />}
        >
            {isSmallDevice ?
                <SimpleList
                    primaryText={record => hideVehicleNumber(record["license_number"])}
                    secondaryText={record => (<div>
                        {record.entry_time && <div><span style={{ color: "#5a5a5a" }}>Entry Time: </span>{moment(record["entry_time"], "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY hh:mm A")}</div>}
                        {record.exit_time && <div><span style={{ color: "#5a5a5a" }}>Model: </span>{moment(record["exit_time"], "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY hh:mm A")}</div>}
                        {record.entry_time && <div><span style={{ color: "#5a5a5a" }}>Duration: </span>{moment(typeof record["entry_time"] === "string" && record["exit_time"] !== "" ? record["exit_time"] : undefined).to(record["entry_time"], true)}</div>}
                        {/* {<div><span style={{ color: "#5a5a5a" }}>Entry Amount: </span>{record.amount_at_entry > 0 ? record.amount_at_entry : "-"}</div>}
                        {<div><span style={{ color: "#5a5a5a" }}>Exit Amount: </span>{record.amount_at_exit > 0 ? record.amount_at_exit : "-"}</div>} */}
                        {(record.amount_at_entry || record.amount_at_exit) && <div><span style={{ color: "#5a5a5a" }}>Total Amount: </span>{record.amount_at_entry || record.amount_at_exit ? `₹ ${record.amount_at_entry + record.amount_at_exit}` : "₹ 0"}</div>}
                        {record.mode_of_payment_at_entry && <div><span style={{ color: "#5a5a5a" }}>Entry Payment Mode: </span>{record.amount_at_entry > 0 ? record.mode_of_payment_at_entry : "-"}</div>}
                        {record.mode_of_payment && <div><span style={{ color: "#5a5a5a" }}>Exit Payment Mode: </span>{record.amount_at_exit > 0 ? record.mode_of_payment : "-"}</div>}
                        {record && <div><span style={{ color: "#5a5a5a" }}>Category: </span>{renderCategoryMob(record)}</div>}
                    </div>)}
                    onContextMenu={event => event.preventDefault()}
                    linkType={false}
                    rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                />
                :
                <Datagrid component={ScrollableTable}>
                    <FunctionField
                        source="vehicle_type"
                        label="Type"
                        render={renderVehicleType}
                        sortable
                    />
                    <FunctionField label="Vehicle number" render={record => record && record.license_number && hideVehicleNumber(record.license_number.toUpperCase())} />
                    <FunctionField source="entry_time" label="Entry Time" render={record => record && moment(record["entry_time"], "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY hh:mm A")} />
                    <FunctionField source="exit_time" label="Exit Time" render={record => record && moment(record["exit_time"], "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY hh:mm A")} />
                    <FunctionField label="Duration" render={record => record && moment(typeof record["entry_time"] === "string" && record["exit_time"] !== "" ? record["exit_time"] : undefined).to(record["entry_time"], true)} />
                    {/* <FunctionField
                        source="amount_at_entry"
                        label="Entry Amount"
                        render={(record) => record.amount_at_entry > 0 ? record.amount_at_entry : "-"}
                        style={{ display: "flex", justifyContent: "center" }}
                    />
                    <FunctionField
                        source="amount_at_exit"
                        label="Exit Amount"
                        render={(record) => record.amount_at_exit > 0 ? record.amount_at_exit : "-"}
                        style={{ display: "flex", justifyContent: "center" }}
                    /> */}
                    <FunctionField
                        source="amount_at_exit"
                        label="Total amount"
                        render={(record) => record && renderTotalAmount(record)}
                        style={{ display: "flex", justifyContent: "center" }}
                    />
                    <FunctionField
                        source="mode_of_payment_at_entry"
                        label="Entry Payment Mode"
                        render={(record) => record && renderPaymentStatusEntry(record)}
                        style={{ display: "flex", justifyContent: "center" }}
                    />

                    <FunctionField
                        source="mode_of_payment"
                        label="Exit Payment Mode"
                        render={(record) => record && renderPaymentStatus(record)}
                        style={{ display: "flex", justifyContent: "center" }}
                    />
                    <FunctionField
                        source="unpaid"
                        label="Category"
                        render={(record) => record && renderCategory(record)}
                        style={{ display: "flex", justifyContent: "center" }}
                    />
                </Datagrid>
            }
        </List>
    </div>
};

